/* @flow */
import BlockedUser from 'entities/BlockedUser';
import Button from 'components/Button.jsx';
import Avatar from 'components/Avatar.jsx';
import MediaObject from 'components/MediaObject.jsx';
import React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';

export default class BlockedUsersListItem extends React.Component {
  props: {
    blockedUser: BlockedUser,
  };

  unblockUser(): void {
    const { blockedUser } = this.props;
    const id = blockedUser.id;
    const name = blockedUser.getName();
    RelationshipActions.unblock(id, name);
  }

  render() {
    const { blockedUser } = this.props;

    return (
      <tr className="BlockedUsersListItem">
        <td>
          <Text
            className="BlockedUsersListItem-userName"
            truncate>
            <MediaObject center>
              <Avatar
                colorHex={blockedUser.getColor()}
                text={blockedUser.getInitials()}
                size="medium"
              />
              {blockedUser.getName()}
            </MediaObject>
          </Text>
        </td>
        <td>
          <Time
            date={blockedUser.getBlockedAt()}
            month="short"
            day="numeric"
          />
        </td>
        <td>
          <Button
            level="secondary"
            size="small"
            onClick={() => this.unblockUser()}>
            Unblock
          </Button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/components/BlockedUsersListItem.jsx